import { render } from "./CaptionCarousel.vue?vue&type=template&id=a01b5238"
import script from "./CaptionCarousel.vue?vue&type=script&lang=js"
export * from "./CaptionCarousel.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\fdm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QResponsive from 'quasar/src/components/responsive/QResponsive.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCarouselControl from 'quasar/src/components/carousel/QCarouselControl.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QResponsive,QCarousel,QCarouselSlide,QScrollArea,QImg,QCarouselControl});
